<dx-select-box #selectBox
               displayExpr="environmentName"
               valueExpr="environmentId"
               [dataSource]="environments"
               [noDataText]="'_pickers.nodata' | translate"
               [placeholder]="'_pickers.placeholder' | translate"
               (selectedItemChange)="onSelectedItemChange($event)">
    <dx-validator>
        <dxi-validation-rule *ngIf="isRequired" type="required" [message]="'_pickers.msgEnvironmentRequired' | translate"></dxi-validation-rule>
    </dx-validator>
</dx-select-box>
